import { store } from '@/store'
import { assetApi, assetV2Api } from '@/store/services'
import { useEffect, useState } from 'react'
import { createSearchParams } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { SelectWrapper } from '../wrapper'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const AssetSelector = ({ value, onChange }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})
  const loadOptions = async (search, _loadedOptions, { page }) => {
    const searchParams = createSearchParams({
      page,
      q: search,
      'order[field]': 'vehicle_patent',
      'order[sort]': 'asc'
    }).toString()

    // legacy siempre paginado; v2 solo se trae en la primera página para evitar duplicados
    const legacy = await store.dispatch(
      assetApi.endpoints.getAssets.initiate(`?${searchParams}`, { subscribe: true })
    ).unwrap()

    let v2 = { assets: [], meta: { pagination: { total_pages: 1 } } }
    if (page === 1) {
      v2 = await store.dispatch(
        assetV2Api.endpoints.getAssetsV2.initiate(searchParams ? `?${searchParams}` : '', { subscribe: true })
      ).unwrap()
    }

    const legacyOptions = (legacy.assets || []).map((a) => ({
      value: a.vehicle_patent || a.name || `asset-${a.id}`,
      label: a.vehicle_patent || a.name || `Asset ${a.id}`,
      data: { attachableType: 'Contractor::Asset', identifier: a.vehicle_patent }
    }))

    const v2Options = page === 1
      ? (v2.assets || []).map((a) => ({
        value: a.identifier_value,
        label: a.identifier_value,
        data: { attachableType: 'Asset', identifier: a.identifier_value }
      }))
      : []

    // Combinar y eliminar duplicados por value
    const deduped = []
    const seen = new Set()
    ;[...legacyOptions, ...v2Options].forEach((opt) => {
      const key = `${opt.data?.attachableType || ''}-${opt.value}`
      if (!seen.has(key)) {
        seen.add(key)
        deduped.push(opt)
      }
    })

    const options = deduped.filter((opt) => {
      if (!search) return true
      return (opt.label || '').toLowerCase().includes(search.toLowerCase())
    })
    const legacyHasMore = page < legacy.meta.pagination.total_pages
    const hasMore = legacyHasMore

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  // Si el selector esta en un popover o modal, se pierde el selectedOption
  // Esta es una forma para rescatarlo si es que se pierde el estado.
  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }
    if (value === selectedOption.value) return

    setSelectedOption({
      value,
      label: value
    })
  }, [value])

  const handleChange = (option = {}) => {
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <SelectWrapper label={t('asset.one')}>
      {(styles) => (
        <AsyncPaginate
          loadingMessage={() => t('select.loading')}
          value={selectedOption?.value ? selectedOption : null}
          debounceTimeout={600}
          placeholder={t('select.one')}
          onChange={handleChange}
          loadOptions={loadOptions}
          styles={styles}
          menuPortalTarget={document.body}
          isClearable
          additional={{
            page: 1
          }}
        />
      )
      }
    </SelectWrapper>
  )
}

AssetSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
